import {SocialMedias} from "@/types/link.type";
import YoutubeSVG from "@/assets/icons/youtube.svg";
import TwitterSVG from "@/assets/icons/twitter.svg";
import TikTokSVG from "@/assets/icons/tiktok.svg";
import InstagramSVG from "@/assets/icons/instagram.svg";
import FacebookSVG from "@/assets/icons/facebook.svg";
import OnlyfansSVG from '@/assets/icons/onlyfans.svg'
import SoundCloudSVG from "@/assets/icons/soundcloud.svg";
import SpotifySVG from "@/assets/icons/spotify.svg";
import TwitchSVG from "@/assets/icons/twitch.svg";
import DiscordSVG from "@/assets/icons/discord.svg";
import TelegramSVG from "@/assets/icons/telegram.svg";
import BehanceSvg from "@/assets/icons/behance.svg";
import LinkedInSVG from "@/assets/icons/linkedin.svg";
import PinterestSVG from "@/assets/icons/pinterest.svg";

const socialMediaToSvgMap: Record<string, string> = {
    [SocialMedias.YOUTUBE]: YoutubeSVG,
    [SocialMedias.TWITTER]: TwitterSVG,
    [SocialMedias.INSTAGRAM]: InstagramSVG,
    [SocialMedias.FACEBOOK]: FacebookSVG,
    [SocialMedias.ONLYFANS]: OnlyfansSVG,
    [SocialMedias.TIKTOK]: TikTokSVG,
    [SocialMedias.SOUNDCLOUD]: SoundCloudSVG,
    [SocialMedias.SPOTIFY]: SpotifySVG,
    [SocialMedias.TWITCH]: TwitchSVG,
    [SocialMedias.DISCORD]: DiscordSVG,
    [SocialMedias.TELEGRAM]: TelegramSVG,
    [SocialMedias.BEHANCE]: BehanceSvg,
    [SocialMedias.LINKEDIN]: LinkedInSVG,
    [SocialMedias.PINTEREST]: PinterestSVG,
}

export function socialMediaToSvg(social: SocialMedias | string) {
    return socialMediaToSvgMap[social as SocialMedias]
}